import React from 'react';
import PropTypes from 'prop-types';

import FileDropZone from '../../../../../../components/FileDropZone';
import { CameraIcon, UploadIcon } from '../icons';
import texts from '../texts';
import { FILE_INPUT_ACCEPT } from '../constants';
import {
  DropWrap,
  DropZoneBox,
  DzIcon,
  DzText,
  DzTitle,
  DzSub,
  DzCta,
  DzSpacer,
  DzGuide,
  DzGuideItem,
} from '../styles';

const DropZone = ({ isEmpty, disabled, onFiles }) => (
  <DropWrap>
    <FileDropZone accept={FILE_INPUT_ACCEPT} multiple disabled={disabled} onFiles={onFiles}>
      {({ isDragging, dropzoneProps, open }) => (
        <DropZoneBox
          $big={isEmpty}
          $dragging={isDragging}
          onClick={open}
          {...dropzoneProps}
        >
          <DzIcon $big={isEmpty}>
            <CameraIcon />
          </DzIcon>
          {isEmpty ? (
            <>
              <DzText $big>
                <DzTitle $big>{texts.dropTitle}</DzTitle>
              </DzText>
              <DzCta>
                <UploadIcon />
                {texts.selectVideos}
              </DzCta>
              <DzSub>{texts.dropSubtitle}</DzSub>
              <DzGuide>
                {texts.constraints.map((constraint) => (
                  <DzGuideItem key={constraint}>{constraint}</DzGuideItem>
                ))}
              </DzGuide>
            </>
          ) : (
            <>
              <DzText>
                <DzTitle>{texts.dropTitleSlim}</DzTitle>
                <DzSub>{texts.dropSubtitleSlim}</DzSub>
              </DzText>
              <DzSpacer />
              <DzCta>
                <UploadIcon />
                {texts.selectVideos}
              </DzCta>
            </>
          )}
        </DropZoneBox>
      )}
    </FileDropZone>
  </DropWrap>
);

DropZone.propTypes = {
  isEmpty: PropTypes.bool.isRequired,
  onFiles: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

DropZone.defaultProps = {
  disabled: false,
};

export default DropZone;
